<script lang="ts" setup>
const { template } = storeToRefs(useTemplateStore());
</script>

<template>
  <section
    v-if="template.location.enabled"
    id="location"
    class="p-section relative min-h-fit flex justify-center overflow-hidden py-0 sm:py-0 2xl:py-0"
  >
    <!-- Mobile Assets -->
    <LazyPLocationAssetsMobile />

    <!-- Desktop Assets -->
    <LazyPLocationAssetsDesktop />

    <!-- Content -->
    <PLocationContent />
  </section>
</template>

<style lang="css" scoped>
:deep(.smooth-wave-flower-left) {
  --rot: 2.2deg;
  --x: 10px;
  --y: 12px;
  --breath: 0.012;

  transform-origin: top right;
  will-change: translate, rotate, scale, filter;

  translate: 0 0;
  rotate: 0deg;
  scale: 1;

  animation:
    alive-sway 6s ease-in-out infinite alternate,
    alive-breath 3s ease-in-out infinite;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.16));
}

:deep(.smooth-wave-flower-right) {
  --rot: -0.2deg;
  --x: -4px;
  --y: 8px;
  --breath: 0.012;

  transform-origin: bottom left;
  will-change: translate, rotate, scale, filter;

  translate: 0 0;
  rotate: 0deg;
  scale: 1;

  animation:
    alive-sway 6s ease-in-out infinite alternate,
    alive-breath 4.5s ease-in-out infinite;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.16));
}
</style>
